import { em } from 'polished'
import styled from 'styled-components'

import { type ISortableTagsProps } from '@ui/blocks/SortableTags/SortableTags'

export interface ISortableTagStyledProps {
  width?: ISortableTagsProps['tagWidth']
  layout?: ISortableTagsProps['layout']
}

export const SortableTagStyled = styled.div<ISortableTagStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  float: left;

  z-index: 1400;

  width: ${(props) =>
    props.width
      ? props.width
      : props.layout === 'y'
        ? `calc(100% - ${em(10)})`
        : `${props.theme.typography.pxToRem(150)}`};

  ${(props) => (props.layout === 'x' ? 'flex-shrink: 0;' : '')}

  padding: 0.5em;

  .sortable-tag-container {
    background: ${(props) => props.theme.colors.content.contentBackground};
    border: 1px solid ${(props) => props.theme.colors.lightGrey};
    border-radius: ${em(3, 12)};

    .order-number {
      font-size: ${em(10, 12)};
      font-weight: ${(props) => props.theme.fontWeights.semibold};
    }
  }
`

export const DragHandleStyled = styled.div`
  ${(props) => props.theme.typography.pxToRem(16)};

  cursor: pointer;
  background: ${(props) => props.theme.colors.offwhite};
  color: ${(props) => props.theme.colors.darkGrey};

  height: ${(props) => props.theme.typography.pxToRem(38)};
  line-height: ${(props) => props.theme.typography.pxToRem(38)};

  padding: 0 ${(props) => props.theme.typography.pxToRem(3)};
`
